// extracted by mini-css-extract-plugin
module.exports = {"loading":"_36LERFGp","rotate":"MajKKecI","path":"_27bTG6MX","dash":"qDI7BzC0"};